import { render, staticRenderFns } from "./CredentialsOfBeneficiary.vue?vue&type=template&id=1bdf99ae&"
import script from "./CredentialsOfBeneficiary.vue?vue&type=script&lang=js&"
export * from "./CredentialsOfBeneficiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports